// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button-module__root--xCMeY {
  /* --button-background: #fff;
  --button-border-color: #e5e5e5;
  --button-color: #1a1a1a; */

  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  padding: 0 20px;
  border: 1px solid var(--button-border-color);
  border-radius: 16px;
  background: var(--button-background);
  color: var(--button-color);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.150390625px;
  cursor: pointer;
  white-space: nowrap;
}

.Button-module__align-center--x9MKl {
  justify-content: center;
  text-align: center;
}

.Button-module__align-left--XgAr_ {
  justify-content: flex-start;
  text-align: left;
}

.Button-module__align-right--RkWsZ {
  justify-content: flex-end;
  text-align: right;
}

.Button-module__shape-default--XldmJ {
  border-radius: 16px;
}

.Button-module__shape-link--GIp7Z {
  width: fit-content;
  height: auto;
  padding: 0 10px;
  border-color: transparent;
  border-radius: 0;
  background: transparent;
}

.Button-module__variant-default--HtpMs {
  --button-background: transparent;
  --button-border-color: transparent;
}

.Button-module__variant-primary--avKMr {
  --button-background: var(--chaek-color-surface-action);
  --button-border-color: var(--chaek-color-surface-action);
  --button-color: var(--chaek-color-text-inverse);
}

.Button-module__variant-secondary--i03KI {
  --button-background: var(--chaek-color-surface-canvas);
  --button-border-color: var(--chaek-color-border-divider);
  --button-color: var(--chaek-color-text-primary);
}

.Button-module__variant-accent--ECBUE {
  --button-background: var(--chaek-color-surface-accent);
  --button-border-color: var(--chaek-color-surface-accent);
  --button-color: #000000;
}

.Button-module__variant-ghost--Yn10J {
  --button-background: #fff;
  --button-border-color: #aaa;
  --button-color: #555;
}

.Button-module__variant-danger--xk86T {
  --button-background: #B3261E;
  --button-border-color: #B3261E;
  --button-color: #fff;
}

.Button-module__variant-danger-weak--vygj0 {
  --button-background: #fff;
  --button-border-color: #B3261E;
  --button-color: #B3261E;
}

.Button-module__size-x-small--T8kG8 {
  height: 34px;
  padding-inline: 4px;
  font-size: 0.6875rem; /* 11px */
}

.Button-module__size-small--wyzgt {
  height: 40px;
  padding-inline: 20px;
  font-size: 0.75rem; /* 12px */
}

.Button-module__size-medium--pkW8O {
  height: 50px;
  padding-inline: 18px;
  font-size: 0.875rem; /* 14px */
}

.Button-module__size-large--oV3hx {
  height: 56px;
  padding-inline: 18px;
  font-size: 0.9375rem; /* 15px */
}

.Button-module__root--xCMeY:disabled,
.Button-module__root--xCMeY[aria-disabled='true'] {
  cursor: not-allowed;
  opacity: 0.45;
}

.Button-module__root--xCMeY:disabled,
.Button-module__root--xCMeY[aria-disabled='true'] {
  --button-background: var(--chaek-color-surface-subtle);
  --button-border-color: var(--chaek-color-surface-subtle);
  --button-color: var(--chaek-color-text-muted);

  opacity: 1;
}

.Button-module__is-block--fanVi {
  width: 100%;
}

.Button-module__root--xCMeY .Button-module__leading--zEd5L {
  padding-right: 6px;
}

.Button-module__root--xCMeY .Button-module__trailing--YODmp {
  padding-left: 6px;
}

.Button-module__root--xCMeY:read-only,
.Button-module__root--xCMeY[readonly] {
  cursor: text;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE;;4BAE0B;;EAE1B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oBAAoB,EAAE,SAAS;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,sDAAsD;EACtD,wDAAwD;EACxD,6CAA6C;;EAE7C,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".root {\n  /* --button-background: #fff;\n  --button-border-color: #e5e5e5;\n  --button-color: #1a1a1a; */\n\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 20px;\n  border: 1px solid var(--button-border-color);\n  border-radius: 16px;\n  background: var(--button-background);\n  color: var(--button-color);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: -0.150390625px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.align-center {\n  justify-content: center;\n  text-align: center;\n}\n\n.align-left {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.align-right {\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.shape-default {\n  border-radius: 16px;\n}\n\n.shape-link {\n  width: fit-content;\n  height: auto;\n  padding: 0 10px;\n  border-color: transparent;\n  border-radius: 0;\n  background: transparent;\n}\n\n.variant-default {\n  --button-background: transparent;\n  --button-border-color: transparent;\n}\n\n.variant-primary {\n  --button-background: var(--chaek-color-surface-action);\n  --button-border-color: var(--chaek-color-surface-action);\n  --button-color: var(--chaek-color-text-inverse);\n}\n\n.variant-secondary {\n  --button-background: var(--chaek-color-surface-canvas);\n  --button-border-color: var(--chaek-color-border-divider);\n  --button-color: var(--chaek-color-text-primary);\n}\n\n.variant-accent {\n  --button-background: var(--chaek-color-surface-accent);\n  --button-border-color: var(--chaek-color-surface-accent);\n  --button-color: #000000;\n}\n\n.variant-ghost {\n  --button-background: #fff;\n  --button-border-color: #aaa;\n  --button-color: #555;\n}\n\n.variant-danger {\n  --button-background: #B3261E;\n  --button-border-color: #B3261E;\n  --button-color: #fff;\n}\n\n.variant-danger-weak {\n  --button-background: #fff;\n  --button-border-color: #B3261E;\n  --button-color: #B3261E;\n}\n\n.size-x-small {\n  height: 34px;\n  padding-inline: 4px;\n  font-size: 0.6875rem; /* 11px */\n}\n\n.size-small {\n  height: 40px;\n  padding-inline: 20px;\n  font-size: 0.75rem; /* 12px */\n}\n\n.size-medium {\n  height: 50px;\n  padding-inline: 18px;\n  font-size: 0.875rem; /* 14px */\n}\n\n.size-large {\n  height: 56px;\n  padding-inline: 18px;\n  font-size: 0.9375rem; /* 15px */\n}\n\n.root:disabled,\n.root[aria-disabled='true'] {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.root:disabled,\n.root[aria-disabled='true'] {\n  --button-background: var(--chaek-color-surface-subtle);\n  --button-border-color: var(--chaek-color-surface-subtle);\n  --button-color: var(--chaek-color-text-muted);\n\n  opacity: 1;\n}\n\n.is-block {\n  width: 100%;\n}\n\n.root .leading {\n  padding-right: 6px;\n}\n\n.root .trailing {\n  padding-left: 6px;\n}\n\n.root:read-only,\n.root[readonly] {\n  cursor: text;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Button-module__root--xCMeY`,
	"align-center": `Button-module__align-center--x9MKl`,
	"align-left": `Button-module__align-left--XgAr_`,
	"align-right": `Button-module__align-right--RkWsZ`,
	"shape-default": `Button-module__shape-default--XldmJ`,
	"shape-link": `Button-module__shape-link--GIp7Z`,
	"variant-default": `Button-module__variant-default--HtpMs`,
	"variant-primary": `Button-module__variant-primary--avKMr`,
	"variant-secondary": `Button-module__variant-secondary--i03KI`,
	"variant-accent": `Button-module__variant-accent--ECBUE`,
	"variant-ghost": `Button-module__variant-ghost--Yn10J`,
	"variant-danger": `Button-module__variant-danger--xk86T`,
	"variant-danger-weak": `Button-module__variant-danger-weak--vygj0`,
	"size-x-small": `Button-module__size-x-small--T8kG8`,
	"size-small": `Button-module__size-small--wyzgt`,
	"size-medium": `Button-module__size-medium--pkW8O`,
	"size-large": `Button-module__size-large--oV3hx`,
	"is-block": `Button-module__is-block--fanVi`,
	"leading": `Button-module__leading--zEd5L`,
	"trailing": `Button-module__trailing--YODmp`
};
export default ___CSS_LOADER_EXPORT___;
